"use client";

import { forwardRef } from "react";
import ProgressFill from "./ProgressFill";

/**
 * Bouton natif avec barre de progression intégrée (façon ElevenLabs).
 *
 * Le contenu (`children`) est rendu deux fois : une base normale, puis un
 * duplicata coloré posé par-dessus et découpé au bord exact de la barre via
 * `clip-path`. Résultat : le texte bascule de couleur au pixel près, pile là
 * où la barre le traverse (ex. noir → blanc sur un fond orange).
 *
 * L'alignement des deux couches est garanti en donnant EXACTEMENT les mêmes
 * classes de mise en page (flex, gap, padding, taille/graisse de police) au
 * bouton et à l'overlay via `overlayClassName`.
 *
 * Pour un LIEN (ou tout autre hôte), utiliser directement `ProgressFill` : le
 * calque se pose sur n'importe quel élément `relative overflow-hidden`.
 *
 * @param {boolean} loading         - action en cours → barre simulée
 * @param {number}  [progress]      - 0..100 pour un mode déterminé (upload…)
 * @param {string}  [fillBg]        - couleur de remplissage de la barre
 * @param {string}  [fillText]      - couleur du texte au-dessus de la barre
 * @param {string}  className       - classes visuelles du bouton (bg, rounded…)
 * @param {string}  overlayClassName- classes de layout à recopier sur l'overlay
 */
const ProgressButton = forwardRef(function ProgressButton(
    {
        loading = false,
        progress,
        fillBg,
        fillText,
        className = "",
        overlayClassName = "",
        children,
        disabled,
        ...rest
    },
    ref,
) {
    return (
        <button
            ref={ref}
            disabled={disabled}
            className={`relative overflow-hidden ${className}`}
            {...rest}
        >
            {children}
            <ProgressFill
                loading={loading}
                progress={progress}
                fillBg={fillBg}
                fillText={fillText}
                className={overlayClassName}
            >
                {children}
            </ProgressFill>
        </button>
    );
});

export default ProgressButton;
